<template>
    <a-entity>

        <a-yoga-layout
            width-auto="1" height-auto="1"
            flex-wrap="nowrap"
            flex-direction="row"
            align-items="center"
            justify-content="space-between"
            yoga-layout-item="margin: 0.02; marginEdge: top"

            padding="0.05"

            geometry="primitive: rounded-plane;" material="color: #001034;"
            push-mesh-backwards

            class="clickable"
        >

            <a-image
                src="/aframe-assets/icons/cancel-padded.png"
                width="0.1" height="0.1"
                yoga-layout-item="position: absolute; right:0.02; top:0.02"
                class="clickable"
                ui-icon
                toggle-modal="#debugPanel"
            />
        </a-yoga-layout>
    </a-entity>
</template>

<script>

export default {
    name: "DebugPanel",
    props: [],
    computed: {
    },
    methods: {
    }
}
</script>

<style scoped>

</style>